// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Bqv3vcxj3kS_qe1UXWuQ {
  margin-top: 5px;
}
.oHWubf7zdsKvxce4CxbB {
  padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/admin-pages/Equipments/Item/index.module.less"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AAEA;EACE,aAAA;AAAF","sourcesContent":[".equipmentBody {\n  margin-top: 5px;\n}\n\n.contentContainer {\n  padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"equipmentBody": `Bqv3vcxj3kS_qe1UXWuQ`,
	"contentContainer": `oHWubf7zdsKvxce4CxbB`
};
export default ___CSS_LOADER_EXPORT___;
